module.exports = __webpack_public_path__ + "img/o_3.5a82bdba.png";